module.exports = __webpack_public_path__ + "static/minute_of_islands-807fe6a4129e3a172917a9567db7ee51.webp";